import { render, staticRenderFns } from "./addBigTraffic.vue?vue&type=template&id=de61dffc&scoped=true"
import script from "./addBigTraffic.vue?vue&type=script&lang=js"
export * from "./addBigTraffic.vue?vue&type=script&lang=js"
import style0 from "./addBigTraffic.vue?vue&type=style&index=0&id=de61dffc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de61dffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de61dffc')) {
      api.createRecord('de61dffc', component.options)
    } else {
      api.reload('de61dffc', component.options)
    }
    module.hot.accept("./addBigTraffic.vue?vue&type=template&id=de61dffc&scoped=true", function () {
      api.rerender('de61dffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/addBigTraffic.vue"
export default component.exports